module.exports = __webpack_public_path__ + "img/payrollBg.55b6debf.png";